import Hero from "@/components/site/Hero";
import { SamplesProvider } from "@/components/site/SamplesContext";
import { Audiences, SamplePlayer } from "@/components/site/Sections";
import KeyFeatures from "@/components/site/KeyFeatures";
import HowItWorks from "@/components/site/HowItWorks";
import { DemoForm, Footer } from "@/components/site/DemoForm";
import { Logo } from "@/components/site/TopBar";

export default function Landing() {
  return (
    <SamplesProvider>
      <main data-testid="landing-page">
        <Hero />
        <HowItWorks />
        <KeyFeatures />
        <Audiences />
        <SamplePlayer />
        <DemoForm />
        <Footer />
      </main>
    </SamplesProvider>
  );
}

const LEGAL = {
  privacy: ["Privacy Policy", "[Placeholder] This page will explain what patient information OnDose stores (names, phone numbers, medicine schedules and call results), why it is stored, who can see it, how long it is kept, and how a patient can stop calls or ask for their data to be deleted. Final text to be written with legal advice before launch."],
  terms: ["Terms of Use", "[Placeholder] This page will set out the terms between OnDose and the hospitals, clinics and pharmacies that use the service. OnDose calls only repeat medicine information entered and confirmed by the care provider and never give medical advice. Final text to be written with legal advice before launch."],
};

export function LegalPage({ kind }) {
  const [title, body] = LEGAL[kind];
  return (
    <main className="min-h-screen bg-[var(--lav)]" data-testid={`legal-${kind}`}>
      <div className="bg-[var(--plum)] px-5 py-5 sm:px-8"><div className="mx-auto max-w-3xl"><Logo /></div></div>
      <article className="mx-auto max-w-3xl px-5 py-16 sm:px-8">
        <h1 className="text-4xl font-extrabold text-[var(--ink)]">{title}</h1>
        <p className="mt-6 leading-relaxed text-[var(--ink)]/75">{body}</p>
        <a href="/" className="mt-10 inline-block font-semibold text-[var(--violet)] underline">Back to home</a>
      </article>
    </main>
  );
}
